import { Card } from 'antd'

import getColor from '~/lib/getColor'
import Box from '~/core/Box'
import {
    BLACK_ALPHA_BOTTOM,
    SUMMARY_KEY,
} from '~/apps/consumer/components/PartViewerModal/logic'
import { PartDetailsCardType } from '~/apps/consumer/components/PartViewerModal/types'

import ReorderFooter from './ReorderFooter'

export default function PartDetailsCard(props: PartDetailsCardType) {
    const { children, title, reorderFooterData } = props

    const isMainPage = title === SUMMARY_KEY

    return (
        <Box justifyContent="end" width="400px">
            <Card
                headStyle={{
                    color: getColor('blackAlpha65'),
                    fontSize: '16px',
                    height: '52px',
                    textAlign: 'center',
                    textTransform: isMainPage ? 'capitalize' : 'none',
                }}
                bodyStyle={{
                    padding: '0',
                    height: '100%',
                }}
                style={{
                    borderRadius: '0 4px 4px 0',
                    width: '400px',
                }}
                bordered={false}
            >
                <Box direction="col" height="100%" justifyContent="between">
                    <Box
                        direction="col"
                        height="100%"
                        style={{
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            paddingBottom: 0,
                        }}
                    >
                        <Box
                            height="100%"
                            padding={isMainPage ? '10px' : '0'}
                            margin-bottom={0}
                            // todo: there no such value "none" for "overflow-x" property. Right now it's just ignored. Please set right value or remove it.
                            //style={{ overflowX: 'none' }}
                        >
                            <Box
                                borderRadius="8px"
                                height="fit-content"
                                width="100%"
                                direction="col"
                                padding={
                                    isMainPage ? '6px 10px 10px 10px' : '16px'
                                }
                            >
                                {children}
                            </Box>
                        </Box>
                    </Box>
                    <Box direction="col" borderTop={BLACK_ALPHA_BOTTOM}>
                        {isMainPage && reorderFooterData && (
                            <ReorderFooter
                                reorderFooterData={reorderFooterData}
                            />
                        )}
                    </Box>
                </Box>
            </Card>
        </Box>
    )
}
